import axios from 'axios';
import localStorageService from './localStorageService';
import history from 'history.js';
import { authRoles } from '../auth/authRoles';

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

class JwtAuthService {
  user = {};
  /*
  user = {
    userId: "1",
    role: '',
    displayName: "Watson Joyce",
    email: "watsonjoyce@gmail.com",
    photoURL: "/assets/images/face-7.jpg",
    age: 25,
    token: "faslkhfh423oiu4h4kj432rkj23h432u49ufjaklj423h4jkhkjh"
  }
  */

  loginWithUsernameAndPassword = async (username, password) => {
    const api = axios.create({
      baseURL: process.env.REACT_APP_API_URL,
      timeout: 10000
    });

    const response = await api.post('/api/auth', { username: username, password: password });
    var user = {
      id: response.data.user.id,
      userId: response.data.user.username,
      role: response.data.user.role,
      displayName: response.data.user.merchantName,
      companyName: response.data.user.companyName,
      email: response.data.user.email,
      photoURL: '/assets/images/face-7.jpg',
      age: 25,
      token: response.data.token,
      terms: response.data.user.terms,
      activeFeatures: response.data.user.activeFeatures
    };
    this.setSession(user.token);
    this.setUser(user);
    return user;
  };

  getProfile = async () => {
    try {
      const response = await axios.get('/api/profile');
      return response;
    } catch (error) {
      this.setSession(null);
      this.removeUser();
      history.push({ pathname: '/session/signin' });
      return error.response;
    }
  };

  loginWithToken = async user => {
    this.setSession(user.token);
    const response = await this.getProfile();
    if (response.status === 200) {
      var newUser = {
        id: response.data.id,
        userId: response.data.username,
        role: response.data.role,
        displayName: response.data.merchantName,
        companyName: response.data.companyName,
        email: response.data.email,
        photoURL: '/assets/images/face-7.jpg',
        age: 25,
        token: user.token,
        terms: response.data.terms,
        activeFeatures: response.data.activeFeatures
      };

      this.activateFeature(user, 'INVOICING');

      return newUser;
    }
    /*
    this.setSession(user.token);
    axios.get('/api/profile').then(response => {
      var newUser = {
        id: response.data.id,
        userId: response.data.username,
        role: response.data.role,
        displayName: response.data.merchantName,
        companyName: response.data.companyName,
        email: response.data.email,
        photoURL: "/assets/images/face-7.jpg",
        age: 25,
        token: user.token,
        terms: response.data.terms
      };
      onComplete(newUser);

      //this.setUser(newUser);
      return newUser;
    }).catch(error => {
      this.setSession(null);
      this.removeUser();
      history.push({ pathname: "/session/signin" });
    });
    */
  };

  logout = () => {
    this.setSession(null);
    this.removeUser();
  };
  activateFeature = (user, feature) => {
    if (user !== null) {
      if (user.activeFeatures.includes(feature)) {
        authRoles.invoicing.push('MERCHANT');
        authRoles.invoicing.push('ADMIN');
        authRoles.invoicing.push('SUPPORT');
      }

      authRoles.contacts.length = 0;
      authRoles.recurring.length = 0;

      if (user.userId.includes(':') === false) {
        authRoles.contacts.push('MERCHANT');
        authRoles.contacts.push('ADMIN');
        authRoles.contacts.push('SUPPORT');

        authRoles.recurring.push('MERCHANT');
        authRoles.recurring.push('ADMIN');
        authRoles.recurring.push('SUPPORT');
      }
    }
  };
  setSession = token => {
    if (token) {
      localStorage.setItem('jwt_token', token);
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
      localStorage.removeItem('jwt_token');
      delete axios.defaults.headers.common['Authorization'];
    }
  };
  setUser = user => {
    this.activateFeature(user, 'INVOICING');

    localStorageService.setItem('auth_user', user);
  };
  removeUser = () => {
    localStorage.removeItem('auth_user');
  };
}

const jwInstance = new JwtAuthService();
export default jwInstance;
